import { Injectable } from '@angular/core';
import { I18nService } from '@dm/core';

// 域状态
export enum DomainStatusE {
    Logout = '0',    // 退出
    Join = '1',      // 加入
    Logouting = '2', // 退出中
    Joining = '3',   // 加入中
    JoinFailed = '4' // 加入失败
}

@Injectable({ providedIn: 'root' })
export class ServiceAdStrService {
    get = this.i18nService.get;

    i18n = {
        configureBtn: this.get('common.configure_button'),
        resetBtn: this.get('settings.domainAuth_term_restoreInitConfig_button'),
        okBtn: this.get('common.confirm_button'),
        cancelBtn: this.get('common.cancel_button'),
        closeBtn: this.get('common.close_button'),
        operationBtn: this.get('common.operation_button'),
        testBtn: this.get('common.test'),
        joinDomainBtn: this.get('settings.domainAuth_term_adDomain_joinDomain_button'),
        logoutDomainBtn: this.get('settings.domainAuth_term_adDomain_exitDomain_button'),
        unConfigedBtn: this.get('settings.domainAuth_term_adDomain_unconfiged_button'),

        vstoreLab: this.get('common.owningVstore_lab'),
        statusLab: this.get('common.status_column'),
        enableLab:  this.get('system.common_term_enable_button'),
        enabledLab: this.get('common.service_enable_value'),
        disabledLab: this.get('common.disabled_label'),

        configServiceAdTitleLab: this.get('settings.domainAuth_term_configServiceAD_title'),
        AdDomainTitleLab: this.get('settings.domainAuth_term_serviceAD_title'),
        cardTitle: this.get('settings.domainAuth_term_AD_lab'),
        fullDomainNameLab: this.get('settings.domainAuth_term_adDomain_fullDomainName_lab'),
        domainUserNameLab: this.get('settings.domainAuth_term_adDomain_administratorUserName_lab'),
        passwordLab: this.get('common.password_label'),
        domainStatusLab: this.get('settings.domainAuth_term_adDomain_domainStatus_lab'),
        organizeUnitLab: this.get('settings.domainAuth_term_adDomain_organizeUnit_lab'),
        systemNameLab: this.get('settings.domainAuth_term_adDomain_systemName_lab'),
        coverSystemNameLab: this.get('settings.domainAuth_term_adDomain_coverSystemName_lab'),
        joinDomainFailedReasonLab: this.get('settings.domainAuth_term_adDomain_jionFailedReason_lab'),
        exitedLab: this.get('settings.domainAuth_term_adDomain_domainStatus_exited_lab'),
        joinedLab: this.get('settings.domainAuth_term_adDomain_domainStatus_joined_lab'),
        exitingLab: this.get('settings.domainAuth_term_adDomain_domainStatus_exiting_lab'),
        joiningLab: this.get('settings.domainAuth_term_adDomain_domainStatus_joining_lab'),
        joinFailedLab: this.get('settings.domainAuth_term_adDomain_domainStatus_joined_lab'),
        organizeUnitInfoLab: this.get('settings.domainAuth_term_adDomain_organizeUnit_info_lab'),
        coverSystemNameInfoLab: this.get('settings.domainAuth_term_adDomain_coverSystemName_info_lab'),
        coverSystemNameEnabledLab: this.get('settings.domainAuth_term_adDomain_coverSystemName_enabled_info_lab'),
        systemNameInfoValid: this.get('settings.domainAuth_term_adDomain_systemName_info_vaild'),
        systemNameFormat:  this.get('settings.domainAuth_term_adDomain_systemName_err_vaild'),
        aconfigServiceAD: this.get('service.vstore_domainAuth_term_configServiceAD_title'),
        preiod: this.get('common.Punctuation_preiod'),
        checkDnsConfigrueTip: this.get('settings.domainAuth_term_adDomain_fullDomainName_err_info'),
        setDnsConfigrue: this.get('settings.userAndRole_task_addLDAPUser_configure_link'),
        exitDomainMsg:  this.get('settings.domainAuth_term_adDomain_exitDomain_confirm_msg'),
        sysNameTip: this.get('settings.domainAuth_term_adDomain_systemName_tip'),
    };

    domainStatusType = {
        0: this.get('settings.domainAuth_term_adDomain_domainStatus_exited_lab'),
        1: this.get('settings.domainAuth_term_adDomain_domainStatus_joined_lab'),
        2: this.get('settings.domainAuth_term_adDomain_domainStatus_exiting_lab'),
        3: this.get('settings.domainAuth_term_adDomain_domainStatus_joining_lab'),
        4: this.get('settings.domainAuth_term_adDomain_domainStatus_jionFailed_lab'),
    };

    // 加入域失败原因
    joinDomainErrorCodeObj = {
        1: this.get('settings.EnumDefine_JOINDOMAINERRORCODE_E_ERRORCODE1'),
        2: this.get('settings.EnumDefine_JOINDOMAINERRORCODE_E_ERRORCODE2'),
        3: this.get('settings.EnumDefine_JOINDOMAINERRORCODE_E_ERRORCODE3'),
        4: this.get('settings.EnumDefine_JOINDOMAINERRORCODE_E_ERRORCODE4'),
        5: this.get('settings.EnumDefine_JOINDOMAINERRORCODE_E_ERRORCODE5'),
        6: this.get('settings.EnumDefine_JOINDOMAINERRORCODE_E_ERRORCODE6'),
        7: this.get('settings.EnumDefine_JOINDOMAINERRORCODE_E_ERRORCODE7'),
        8: this.get('settings.EnumDefine_JOINDOMAINERRORCODE_E_ERRORCODE8'),
        9: this.get('settings.EnumDefine_JOINDOMAINERRORCODE_E_ERRORCODE9'),
        10: this.get('settings.EnumDefine_JOINDOMAINERRORCODE_E_ERRORCODE10'),
        11: this.get('settings.EnumDefine_JOINDOMAINERRORCODE_E_ERRORCODE11'),
        12: this.get('settings.EnumDefine_JOINDOMAINERRORCODE_E_ERRORCODE12'),
        13: this.get('settings.EnumDefine_JOINDOMAINERRORCODE_E_ERRORCODE13'),
        14: this.get('settings.EnumDefine_JOINDOMAINERRORCODE_E_ERRORCODE14'),
        15: this.get('settings.EnumDefine_JOINDOMAINERRORCODE_E_ERRORCODE15'),
        16: this.get('settings.EnumDefine_JOINDOMAINERRORCODE_E_ERRORCODE16'),
        17: this.get('settings.EnumDefine_JOINDOMAINERRORCODE_E_ERRORCODE17'),
    };

    constructor(
        private i18nService: I18nService,
    ) { }
}
